"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationBasedShareTexts = void 0;
exports.OrganizationBasedShareTexts = new Map([
    // Bayswater Education - 89702086809285
    [
        "08dc18e0-0ea7-e0c0-e269-06b56de71ebb",
        "Check out my new digital credential from Bayswater Education! #digitalbadges #digitalcertificate #digitalcredentials #studyabroad #bayswatereducation #studybayswater #globalskills #globalskillscertificate",
    ],
    // Elevation Chief of Staff - 77252270057171
    [
        "08dc85ad-c3c2-42ce-8bff-e9534a643c5a",
        "🎓 Exciting News! 🌟 I'm proud to announce that I have officially completed the Elevation Chief of Staff Training program and am now certified as a Chief of Staff! This journey has been incredibly enriching, equipping me with the skills and insights needed to excel in this impactful profession.",
    ],
]);
